import React from "react";

import Layout from "../../../Layout";
import HeaderReports from "../../HeaderReports";
/*import HeaderMessageForwardingTool from "./HeaderMessageForwardingTool";*/
import SearchMessageForwarding from "./SearchMessageForwarding";
import BulkMessageForwarding from "./BulkMessageForwarding";
import ListMessageForwarding from "./ListMessageForwarding";
import useUserStore from "../../../../utils/storeApp";

const MessageForwarding = () => {
  const { isUserLogedIn, userRole, userToken } = useUserStore((state) => ({
    isUserLogedIn: state.isUserLogedIn,
    userRole: state.userRole,
    userToken: state.userToken,
  }));

  return (
    <Layout>
     <HeaderReports />
      {/* <HeaderMessageForwardingTool /> */}
      <ListMessageForwarding />
      <SearchMessageForwarding />
      <BulkMessageForwarding />
    </Layout>
  );
};

MessageForwarding.propTypes = {};

MessageForwarding.defaultProps = {};

export default MessageForwarding;
